import React from 'react';

const BaldwinFooter = () => {
    return (
        <div className={'BaldwinFooter'}>
            <div>Baldwin Park Animal Care Center</div>
            <div>4275 Elton St.</div>
            <div>Baldwin Park, CA 91706</div>
            <div>(626) 962-3577</div>
        </div>
    );
};

export default BaldwinFooter;
